import React from 'react';
import PropTypes from 'prop-types';

export const binSizes = [
  { id: '03E565BC-1686-4347-82FB-7BB011EBCD8F', label: 'Small', image: '/bin-sizes/small.jpg' },
  { id: '3337B4B8-7640-4DC2-B1B1-9F8AA19A568D', label: 'Medium', image: '/bin-sizes/medium.jpg' },
  { id: 'AB7C4853-AA8E-46CC-ABC3-E2A99E96899A', label: 'Large', image: '/bin-sizes/large.jpg' },
];

const BinRequirementsStep = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium mb-4">Bin Size</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {binSizes.map((size) => (
          <label key={size.id} className="flex flex-col items-center p-4 border rounded-lg cursor-pointer">
            <img src={size.image} alt={size.label} className="w-full h-32 object-cover mb-2 rounded" />
            <div className="flex items-center">
              <input
                type="radio"
                name="binSizeId"
                value={size.id}
                checked={formData.binSizeId === size.id}
                onChange={handleInputChange}
                className="mr-2"
              />
              <span>{size.label}</span>
            </div>
          </label>
        ))}
      </div>
      {errors.binSizeId && <p className="text-red-500 mt-1">{errors.binSizeId}</p>}
    </div>
  );
};

BinRequirementsStep.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default BinRequirementsStep;